import { CONVEYANCE_TYPES } from '@koala/sdk';
import styled from 'styled-components';
import { Heading, Text } from '@/components/cart/text';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { Button } from '@/components/uielements/button/button';
import { Stack } from '@/components/uielements/stack/stack';
import { useSelector } from '@/redux';
import { useDialogContext } from '@/utils/useDialogContext';
import { toggleBodyScroll } from '@/utils/global';

export const DeliveryDetails = () => {
  const { onCancel } = useDialogContext();

  const fulfillment = useSelector((state) => state.app.basket.fulfillment);
  const strings = useSelector((state) => state.app.cmsConfig.strings);

  const openConveyanceDeliveryDropdown = () => {
    onCancel();
    toggleBodyScroll();
    document.getElementById('delivery-conveyance-button')?.click();
    setTimeout(() => {
      document.getElementById('edit-delivery-address-button')?.click();
    }, 700);
  };

  if (!fulfillment?.address || fulfillment.type !== CONVEYANCE_TYPES.DELIVERY) {
    return null;
  }

  return (
    <Wrapper>
      <Stack direction="vertical" gap="var(--size-1)" align="leading">
        <Heading>
          <StringAccessor accessor="cart_checkout.delivery_address_header" />
        </Heading>

        <Stack
          align="leading"
          direction="vertical"
          gap="0"
          overrides={{
            color: '#595959',
            fontSize: '.875rem',
          }}
        >
          <Address>
            <Text>
              {fulfillment.address.street_address}
              {fulfillment.address.street_address_2 && (
                <>
                  <br />
                  {fulfillment.address.street_address_2}
                </>
              )}
              <br />
              {`${fulfillment.address.city}, ${fulfillment.address.state || ''} ${
                fulfillment.address.zip_code
              }`}
            </Text>
          </Address>
        </Stack>
      </Stack>

      {strings.cart_checkout?.change_location_cta && (
        <Button onClick={openConveyanceDeliveryDropdown}>
          <StringAccessor accessor="cart_checkout.change_delivery_address_cta" />
        </Button>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  gap: 'var(--size-1)',
  borderTop: '1px solid var(--sidecart__divider-color)',
  width: '100%',
  padding: 'var(--size-6)',

  // Move Change Location CTA to right side to create more space in side cart when mobile view
  '& > :last-child': {
    marginLeft: 'auto',
  },

  '@media (min-width: 768px)': {
    flexDirection: 'column',
    padding: 'var(--size-6) var(--size-24) var(--size-6) var(--size-6)',

    '& > :last-child': {
      marginLeft: 0,
    },
  },
});

const Address = styled.address({
  fontStyle: 'normal',
});
